import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { Loader2, Network } from 'lucide-react';
import { MermaidInline } from '../../../tools/atoms/MermaidInline';
export const isGenerateMermaidDiagramOutput = (output)=>{
    return typeof output === 'object' && output !== null && 'success' in output && 'attempts' in output && typeof output.success === 'boolean';
};
/**
 * Renders the generateMermaidDiagram tool call with diagram preview
 * Shows loading state while diagram is being generated
 * Renders the diagram inline using MermaidInline component
 */ export function GenerateMermaidDiagramToolCall({ output, isRunning }) {
    // While running, show loading state
    if (isRunning) {
        return /*#__PURE__*/ _jsx("div", {
            className: "border rounded-lg p-4 bg-muted/30",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-3",
                children: [
                    /*#__PURE__*/ _jsx(Loader2, {
                        className: "h-4 w-4 animate-spin text-muted-foreground"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "text-sm font-medium",
                                children: "Generating Mermaid diagram..."
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "text-xs text-muted-foreground mt-1",
                                children: "Querying documentation and validating syntax"
                            })
                        ]
                    })
                ]
            })
        });
    }
    // Success state - render the diagram
    if (output?.success && output.diagram) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "border rounded-lg p-4 bg-muted/30",
            "data-testid": Testids.mermaid.diagramGenerated,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center gap-2 mb-3",
                    children: [
                        /*#__PURE__*/ _jsx(Network, {
                            className: "h-4 w-4 text-muted-foreground"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "text-sm font-medium",
                            children: [
                                "Mermaid Diagram Generated",
                                output.diagramType && /*#__PURE__*/ _jsxs("span", {
                                    className: "text-xs text-muted-foreground ml-2",
                                    children: [
                                        "(",
                                        output.diagramType,
                                        ")"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "bg-background rounded-md p-2",
                    children: /*#__PURE__*/ _jsx(MermaidInline, {
                        code: output.diagram
                    })
                })
            ]
        });
    }
    // Error state
    if (output && !output.success) {
        const errorMessage = output.error?.trim() || 'Failed to generate valid diagram after multiple attempts. Please try again with a more specific objective.';
        return /*#__PURE__*/ _jsxs("div", {
            className: "border border-destructive/50 rounded-lg p-4 bg-destructive/10",
            "data-testid": Testids.mermaid.diagramFailed,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center gap-2 mb-2",
                    children: [
                        /*#__PURE__*/ _jsx(Network, {
                            className: "h-4 w-4 text-destructive"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-sm font-medium text-destructive",
                            children: "Diagram Generation Failed"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-sm text-destructive/90",
                    children: errorMessage
                }),
                output.validationErrors && output.validationErrors.length > 0 && /*#__PURE__*/ _jsxs("details", {
                    className: "mt-2",
                    children: [
                        /*#__PURE__*/ _jsxs("summary", {
                            className: "text-xs text-destructive/70 cursor-pointer hover:text-destructive",
                            children: [
                                "Validation errors (",
                                output.validationErrors.length,
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "mt-1 text-xs text-destructive/70 space-y-1",
                            children: output.validationErrors.map((error, idx)=>/*#__PURE__*/ _jsx("div", {
                                    className: "pl-2 border-l-2 border-destructive/30",
                                    children: error
                                }, idx))
                        })
                    ]
                })
            ]
        });
    }
    return null;
}
